/**
 * CustomersPage - Page wrapper for customers management
 */

import React from "react";
import CustomersView from "../features/customers/views/CustomersView";

const CustomersPage = () => {
  return <CustomersView />;
};

export default CustomersPage;

